<template>
    <div class="flex flex-col">
        <fieldset class="mb-6 grid gap-2 border p-4">
            <legend>Controls</legend>
            <label>
                Font Awesome icon string
                <input
                    v-model="iconString"
                    class="my-2 w-full border border-teal-500 p-1 font-mono shadow-[0_0_5px] shadow-teal-500"
                />
            </label>

            <label>
                Tooltip text
                <input
                    v-model="tooltipText"
                    class="my-2 w-full border border-teal-500 p-1 font-mono shadow-[0_0_5px] shadow-teal-500"
                />
            </label>

            <div>
                Tooltip location
                <div class="flex items-center gap-6 pt-1">
                    <label class="inline-flex items-center gap-2">
                        <input
                            v-model="tooltipLocation"
                            type="radio"
                            value="top"
                        />
                        Top
                    </label>
                    <label class="inline-flex items-center gap-2">
                        <input
                            v-model="tooltipLocation"
                            type="radio"
                            value="bottom"
                        />
                        Bottom
                    </label>
                    <label class="inline-flex items-center gap-2">
                        <input
                            v-model="tooltipLocation"
                            type="radio"
                            value="left"
                        />
                        Left
                    </label>
                    <label class="inline-flex items-center gap-2">
                        <input
                            v-model="tooltipLocation"
                            type="radio"
                            value="right"
                        />
                        Right
                    </label>
                </div>
            </div>
        </fieldset>
        <div class="flex flex-col md:flex-row">
            <div class="w-full p-2 md:w-1/2">
                <h2>Default</h2>
                <div class="grid grid-cols-2 grid-rows-2 gap-2 px-4 pb-4">
                    <h3>Medium</h3>
                    <h3>Small</h3>
                    <div class="flex items-center">
                        <DsIconButton
                            :icon="iconString"
                            size="md"
                            :tooltip-location="tooltipLocation"
                            :tooltip-text="tooltipText"
                        />
                    </div>
                    <div class="flex items-center">
                        <DsIconButton
                            :icon="iconString"
                            size="sm"
                            :tooltip-location="tooltipLocation"
                            :tooltip-text="tooltipText"
                        />
                    </div>
                </div>
            </div>
            <div class="w-full p-2 md:w-1/2">
                <h2>OnDark</h2>
                <div class="dark-bg grid grid-cols-2 grid-rows-2 gap-2 px-4 pb-4">
                    <h3>Medium</h3>
                    <h3>Small</h3>
                    <div class="flex items-center">
                        <DsIconButton
                            :icon="iconString"
                            :on-dark-bg="true"
                            size="md"
                            :tooltip-location="tooltipLocation"
                            :tooltip-text="tooltipText"
                        />
                    </div>
                    <div class="flex items-center">
                        <DsIconButton
                            :icon="iconString"
                            :on-dark-bg="true"
                            size="sm"
                            :tooltip-location="tooltipLocation"
                            :tooltip-text="tooltipText"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { TooltipPlacementType } from '@/components/design-system/design-system';
import DsIconButton from '@ds/DsIconButton.vue';
import { ref } from 'vue';

const iconString = ref('fa-close');
const tooltipLocation = ref<TooltipPlacementType>('top');
const tooltipText = ref('Close');
</script>

<style scoped lang="scss">
h2 {
    margin-top: 2rem;
    margin-bottom: 1rem;

    &:first-child {
        margin-top: 0;
    }
}

h3 {
    font-weight: 500;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
}

.dark-bg {
    @apply bg-ds-primary-900 text-white;
}
</style>
